import iconPath from '@/assets/device-icons/studio-display.svg';

interface StudioDisplayIconProps {
  className?: string;
}

export const StudioDisplayIcon = ({ className = "h-5 w-5" }: StudioDisplayIconProps) => {
  return (
    <img 
      src={iconPath} 
      alt="Studio Display" 
      className={className}
    />
  );
};
